export default "__VITE_ASSET__dfab30b8__"